export const initialState = {
  AdminDetails: []
};
